<template>
    <div v-if="loaded" class="container space-y-6 py-12">

        <h1 class="text-4xl font-heading font-bold md:text-5xl">
            Your Completed Courses
        </h1>

        <div class="container space-y-6">
            <PaginationLinks
                v-if="meta.total"
                :meta="meta"
                @change="onPageChange"/>

            <div class="space-y-10">
                <CoursePanel v-for="course in rows" :key="course.id" :course="course" :showLink="false"/>
                <div v-if="!rows.length" class="border-2 border-dashed border-gray-200 p-4 text-center">
                    <p>Nothing to display</p>
                </div>
            </div>

            <PaginationLinks
                v-if="meta.total"
                :meta="meta"
                @change="onPageChange"/>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import PaginationPage from "@/Mixins/PaginationPage";
import PaginationLinks from "@/Components/PaginationLinks.vue";
import CoursePanel from "@/Components/CoursePanel.vue";
import CourseSearch from "@/Components/CourseSearch.vue";

export default {

    name: "CompletedCoursesPage",

    mixins: [PaginationPage],

    components: {
        PaginationLinks,
        CoursePanel,
    },

    async beforeRouteEnter(to, from, next) {
        const data = (await axios.get(route('api.courses.completed'), {params: to.query})).data;
        next(vm => vm.setData(data));
    },

    async beforeRouteUpdate(to, from) {
        const data = (await axios.get(route('api.courses.completed'), {params: to.query})).data;
        this.setData(data);
    },
};

</script>
